var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Google_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6 12.278c0-.816-.067-1.636-.208-2.438H13.073v4.62h6.482a5.554 5.554 0 0 1-2.399 3.647v2.999h3.867c2.271-2.09 3.576-5.177 3.576-8.828Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.073 24.001c3.237 0 5.966-1.062 7.955-2.897l-3.867-2.998c-1.076.732-2.465 1.146-4.083 1.146-3.13 0-5.785-2.112-6.738-4.951H2.35v3.09a12.002 12.002 0 0 0 10.723 6.61Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.336 14.299a7.188 7.188 0 0 1 0-4.595v-3.09H2.35a12.01 12.01 0 0 0 0 10.776l3.986-3.091Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.073 4.75a6.52 6.52 0 0 1 4.604 1.799l3.426-3.426A11.533 11.533 0 0 0 13.073 0 11.998 11.998 0 0 0 2.35 6.615l3.986 3.09c.948-2.843 3.607-4.955 6.737-4.955Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Google_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.833)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgGoogle;